import { Injectable } from '@angular/core';
import { Observable, Subscriber } from 'rxjs';
import { TransferError } from '../../shared/model/transfer-error';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable()
export class TransferErrorService {

  constructor(private http: HttpClient) {
  }


  /**
   * Get a list of all failed transfers
   */
  getTransferErrors(): Observable<TransferError[]> {
    return new Observable<TransferError[]>((observer: Subscriber<TransferError[]>) => {
      this.http.get(environment.endpoints.clientBaseUrl + environment.endpoints.getTransferErrors)
        .subscribe(
          (transferErrors: TransferError[]) => {
            observer.next(transferErrors);
          },
          (error: any) => {
            observer.error(error);
          }
        );
    });
  }

}
